import Icon from "./Icon.jsx";

const COLORS = {
  terracotta: { bg: "var(--terracotta)", fg: "#fff", wash: "var(--terracotta-wash)" },
  ink: { bg: "var(--ink)", fg: "var(--cream)", wash: "var(--cream-3)" },
  gold: { bg: "var(--gold)", fg: "#fff", wash: "var(--gold-wash)" },
  gem: { bg: "var(--gem)", fg: "#fff", wash: "var(--gem-wash)" },
  moss: { bg: "var(--moss)", fg: "#fff", wash: "var(--moss-wash)" },
};

export default function TrackCard({ track, onClick }) {
  const c = COLORS[track.color] || COLORS.terracotta;
  return (
    <button
      onClick={onClick}
      className="card"
      style={{
        textAlign: "left",
        padding: 0,
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 160ms ease, box-shadow 200ms ease",
        border: "1px solid var(--line)",
        background: "#FBF7F0",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 12px 30px -12px rgba(31,27,22,0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "";
        e.currentTarget.style.boxShadow = "";
      }}
    >
      <div
        style={{
          background: c.wash,
          padding: "28px 22px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottom: "1px solid var(--line)",
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            background: c.bg,
            color: c.fg,
            borderRadius: 10,
            display: "grid",
            placeItems: "center",
            fontFamily: "var(--font-serif)",
            fontSize: 26,
            lineHeight: 1,
          }}
        >
          {track.glyph}
        </div>
        <span className="chip" style={{ background: "#FBF7F0" }}>{track.level}</span>
      </div>
      <div style={{ padding: 22 }}>
        <div className="serif" style={{ fontSize: 26, letterSpacing: "-0.01em", marginBottom: 6 }}>
          {track.title}
        </div>
        <div style={{ color: "var(--ink-3)", fontSize: 14, marginBottom: 18 }}>{track.subtitle}</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div className="mono" style={{ fontSize: 12, color: "var(--ink-3)" }}>
            {track.lessons} lessons · {track.minutes} min
          </div>
          <span
            style={{
              color: "var(--terracotta)",
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontWeight: 500,
              fontSize: 13,
            }}
          >
            Start <Icon name="arrow-right" size={14} color="var(--terracotta)" />
          </span>
        </div>
      </div>
    </button>
  );
}
